import * as Yup from 'yup';
import { FormDataRevoke } from '../types.ts';
import {
  baseDocumentFieldsSchema,
  createCounterpartyNameSchema,
  createCounterpartyCodeSchema,
} from '../ApplicationValidationSchema.ts';

export const validationSchemaRevoke = (formData: FormDataRevoke) =>
  Yup.object().shape({
    ...baseDocumentFieldsSchema,
    financialServicesCounterpartyName: createCounterpartyNameSchema(
      () =>
        !!(
          formData?.financialServices?.selected &&
          formData?.financialServices?.clientType === 'REPRESENTATIVE'
        )
    ),
    financialServicesCounterpartyCode: createCounterpartyCodeSchema(
      () =>
        !!(
          formData?.financialServices?.selected &&
          formData?.financialServices?.clientType === 'REPRESENTATIVE'
        ),
      { withValidation: true, withLengthValidation: true }
    ),
    businessRelationCounterpartyName: createCounterpartyNameSchema(
      () =>
        !!(
          formData?.businessRelationship?.selected &&
          formData?.businessRelationship?.clientType === 'REPRESENTATIVE'
        )
    ),
    businessRelationCounterpartyCode: createCounterpartyCodeSchema(
      () =>
        !!(
          formData?.businessRelationship?.selected &&
          formData?.businessRelationship?.clientType === 'REPRESENTATIVE'
        ),
      { withValidation: true, withLengthValidation: true }
    ),
  });
